import { api } from '@/lib/api/client';

export type DispositionKind = 'off_station' | 'operations' | 'write_off' | 'recount';

export interface StockMovement {
  at: string;
  qty: number;
  stockId: number;
  item: string;
  eventId: number | null;
  event: string | null;
  from: string;
  to: string;
  note: string | null;
  kind: 'disposition' | 'closing' | 'allocation' | 'delivered';
}

/**
 * El libro de movimientos del almacén (derivado en el servidor de
 * asignaciones, canjes entregados, cierres y disposiciones) y la escritura de
 * disposiciones sobre lo que quedó sin destino en un evento cerrado.
 */
export const movementsApi = {
  recent: (limit = 40) => api.get<StockMovement[]>(`/xk-stock-movements?limit=${limit}`),
  dispose: (eventId: number, body: { stockId: number; kind: DispositionKind; quantity: number; note?: string }) =>
    api.post<{ id: number; open: number }>(`/xk-event/${eventId}/dispositions`, body),
};
